<template>
  <div class="moblie_menu">
    <!-- 我的写手 -->
    <div v-if="showWriter" id="writer_menu" class="moblie_box">
      <div v-for="(item, index) in mobile_writer_menu_list" :key="index">
        <div
          :class="isSelect == index ? 'select_menu_item ' : 'mobile_menu_item'"
          @click="handleMenuItem(index, item)"
          key="index"
        >
          <div class="line_item "></div>
          <i :class="item.iconUrl"></i>
          <div class="moblie_link">
            {{ item.pathName }}
          </div>
        </div>
      </div>
    </div>
    <!-- 我的数据 -->
    <div id="writerData_menu" v-if="showWriterData" class="moblie_box">
      <div v-for="(item, index) in mobile_writerData_menu_list" :key="index">
        <div
          :class="isSelect == index ? 'select_menu_item ' : 'mobile_menu_item'"
          @click="handleMenuItem(index, item)"
          key="index"
        >
          <div class="line_item "></div>
          <i :class="item.iconUrl"></i>
          <div class="moblie_link">
            {{ item.pathName }}
          </div>
        </div>
      </div>
    </div>
    <!-- 当前菜单 -->
    <div id="current_writer_menu" class="current_menu" v-show="showCurrentMenu">
      <div class="current_menu_item">
        <div class="line_item "></div>
        <i :class="currentMenuIcon"></i>
        {{ currentMenuName }}
      </div>
      <div class="more_menu" @click="handleMore">
        <i class="el-icon-arrow-down"></i>更多
      </div>
    </div>
    <!-- 底部菜单按钮 -->
    <div id="foot_writer_menu" class="foot_list_box">
      <div
        class="foot_item"
        :class="isActive == 0 ? 'foot_item_active' : 'foot_item'"
        @click="handleWriter(0)"
      >
        写手
      </div>
      <div
        class="foot_item"
        :class="isActive == 1 ? 'foot_item_active' : 'foot_item'"
        @click="handleWriter(1)"
      >
        我的数据
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile_writer_menu_list: [
        {
          iconUrl: "iconfont icon-kehu",
          pathUrl: "/MyWriter",
          pathName: "我的写手"
        },
        {
          iconUrl: "iconfont icon-wp-sj",
          pathUrl: "/OrderCenter",
          pathName: "接单中心"
        },
        {
          iconUrl: "iconfont icon-wp-sj",
          pathUrl: "/WriterBookInfo",
          pathName: "写手书籍信息"
        },
        {
          iconUrl: "iconfont icon-gonghaiguanli",
          pathUrl: "/WriterHighSeas",
          pathName: "写手公海信息"
        },
        {
          iconUrl: "iconfont icon-kehuchazhong",
          pathUrl: "/UploadManuscript",
          pathName: "每日上传稿件"
        },
        {
          iconUrl: "iconfont icon-kehuchazhong",
          pathUrl: "/ManuscriptManage",
          pathName: "稿费预支及暂压稿"
        },
        {
          iconUrl: "iconfont icon-kehuchazhong",
          pathUrl: "/ManuscriptAdvance",
          pathName: "稿费预支申请记录"
        },
        {
          iconUrl: "iconfont icon-kehuchazhong",
          pathUrl: "/ManuscriptTemporary",
          pathName: "暂压稿费申请记录"
        },
        {
          iconUrl: "iconfont icon-chuyuanjiesuan",
          pathUrl: "/writerFeeExpenditure",
          pathName: "其余费用支出"
        },
        {
          iconUrl: "iconfont icon-chuyuanjiesuan",
          pathUrl: "/writerFeeIncome",
          pathName: "其余费用收入"
        },
        {
          iconUrl: "iconfont icon-chuyuanjiesuan",
          pathUrl: "/ManuscriptDeposit",
          pathName: "压稿管理"
        },
        {
          iconUrl: "iconfont  icon-jilu",
          pathUrl: "/UploadFileRecord",
          pathName: "文件上传记录"
        },
        {
          iconUrl: "iconfont  icon-zongcejieguochakan",
          pathUrl: "/writerCheaterPool",
          pathName: "骗子库"
        },
        {
          iconUrl: "iconfont icon-zongcejieguochakan",
          pathUrl: "/InitPressManuscript",
          pathName: "初始压稿"
        },
        {
          iconUrl: "iconfont icon-shangchuan",
          pathUrl: "/ManuscriptUpload",
          pathName: "上传周稿"
        }
      ],
      mobile_writerData_menu_list: [
        {
          iconUrl: "iconfont icon-kaohe",
          pathUrl: "/WriterExamine",
          pathName: "我的考核"
        },
        {
          iconUrl: "iconfont icon-data1",
          pathUrl: "/WriterData",
          pathName: "我的数据"
        },
        {
          iconUrl: "iconfont icon-register",
          pathUrl: "/WriterDayRecordMobile",
          pathName: "写手日结登记"
        },
        {
          iconUrl: "iconfont  icon-shuji",
          pathUrl: "/WriterDaySheet",
          pathName: "写手日结表"
        },
        {
          iconUrl: "iconfont icon-register",
          pathUrl: "/WriterWeekRecordMobile",
          pathName: "写手周结登记"
        },
        {
          iconUrl: "iconfont  icon-shuji",
          pathUrl: "/WriterWeekSheet",
          pathName: "写手周结表"
        }
      ],
      currentMenuName: "", //当前菜单名称
      currentMenuIcon: "", //当前菜单图标
      showCurrentMenu: false, //展示当前菜单
      showWriter: false, //金主、写手菜单
      showWriterData: false, //数据中心
      outsideShow: false, //区域外部
      isSelect: 0, //是否选择菜单项 0 ：是  1： 否
      isActive: 0 //选项卡
    };
  },
  // props: {
  //   showWriter: Boolean
  // },
  created() {},
  mounted() {
    // 监听，除了点击自己，点击其他地方将自身隐藏
    document.addEventListener("click", e => {
      const writerMenu = document.getElementById("writer_menu"); //写手
      const writerDataMenu = document.getElementById("writerData_menu"); //我的数据
      const currentWriterMenu = document.getElementById("current_writer_menu"); //
      const footWriterMenu = document.getElementById("foot_writer_menu"); //
      // 写手
      if (writerMenu && footWriterMenu) {
        if (
          !writerMenu.contains(e.target) &&
          !footWriterMenu.contains(e.target)
        ) {
          this.showWriter = !this.showWriter;
          this.showCurrentMenu = true;
        }
      }
      // 我的数据
      if (writerDataMenu && footWriterMenu) {
        if (
          !writerDataMenu.contains(e.target) &&
          !footWriterMenu.contains(e.target)
        ) {
          this.showWriterData = !this.showWriterData;
          this.showCurrentMenu = true;
        }
      }
      // 查看更多;
      if (currentWriterMenu) {
        if (currentWriterMenu.contains(e.target)) {
          if (this.isActive == 0) {
            this.showWriter = true;
          } else {
            this.showWriterData = true;
          }
          this.showCurrentMenu = false;
        }
      }
    });
  },
  methods: {
    // 底部菜单选择
    handleWriter(val) {
      this.isActive = val;
      // this.showMenu = !this.showMenu;
      if (val == 0) {
        // 金主
        this.showWriter = !this.showWriter;

        this.showCurrentMenu = false;
        this.showWriterData = false;
        if (this.showWriter == false) {
          this.showCurrentMenu = !this.showCurrentMenu;
        }
      } else {
        // 我的数据
        this.showWriterData = !this.showWriterData;
        this.showCurrentMenu = false;
        this.showWriter = false;
        if (this.showWriterData == false) {
          this.showCurrentMenu = !this.showCurrentMenu;
        }
      }
    },
    // 选择子菜单
    handleMenuItem(index, data) {
      var pathURL = data.pathUrl;
      this.isSelect = index;
      this.currentMenuName = data.pathName;
      this.currentMenuIcon = data.iconUrl;
      this.$router.push(pathURL).catch(err => {});
    },
    // 查看更多
    handleMore() {
      this.showCurrentMenu = false;
      if (this.isActive == 0) {
        // 金主
        this.showWriter = true;
      } else {
        // 我的数据
        this.showWriterData = true;
      }
    }
  }
};
</script>
<style scoped>
.moblie_box {
  width: 99%;
}
.mobile_menu_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  color: #000;
  font-size: 10px;
  padding: 5px 25px;
}
.mobile_menu_item:hover,
.mobile_menu_item .moblie_link:hover {
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 0px;
}

.moblie_link {
  text-decoration: none;
  color: #000;
}
.select_menu_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 25px;
}
.select_menu_item .moblie_link {
  color: #157df8;
}
.select_menu_item .line_item {
  display: block;
}
.select_menu_item .line_item {
  width: 5px;
  height: 35px;
  background: #157df7;
  margin-left: -25px;
  margin-bottom: -5px;
  margin-top: -5px;
  margin-right: 20px;
}
.current_menu {
}

.current_menu_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 25px;
}
.current_menu_item .line_item {
  width: 5px;
  height: 35px;
  background: #157df7;
  margin-left: -25px;
  margin-bottom: -5px;
  margin-top: -5px;
  margin-right: 20px;
}
.more_menu {
  color: #157df8;
  text-align: center;
  padding: 5px;
}
.foot_list_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #fff;
}
.foot_item {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 99999;
}
.foot_item_active {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 99999;
  background: #94c4fc;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileWriter.vue